export class ConstantsTableColsErgSocKombi {
    static readonly SOC_CODE: string = "SOC_CODE";
    static readonly SOC_MERKMAL: string = "SOC_MERKMAL";
    static readonly SO_BETRAG: string = "SO_BETRAG";
    static readonly BEMERKUNG: string = "BEMERKUNG";
  
    public static getColumns(): string[] {
      return [this.SOC_CODE, this.SOC_MERKMAL, this.SO_BETRAG, this.BEMERKUNG];
    }
  }
  






   